import React, { useEffect, useState } from 'react';
import axios from 'axios';
import FormularioDesconto from './FormularioDesconto';

export default function EditarDesconto(props) {
    const token = localStorage.getItem('token');

    const [discountCode, setDiscountCode] = useState('');
    const [valorDesconto, setValorDesconto] = useState('');
    const [duracaoMeses, setDuracaoMeses] = useState('');
    const [salvando, setSalvando] = useState(false);

    useEffect(() => {
        const getDescontoById = async () => {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/getDescontoById/${props.idDesconto}`, {
                headers: {
                    Authorization: token
                }
            });
            setDiscountCode(response?.data?.desconto?.discountCode);
            setValorDesconto(response?.data?.desconto?.valorDesconto);
            setDuracaoMeses(response?.data?.desconto?.duracaoMeses);
        }
        // Antes de escolher um desconto não há o que buscar
        if (props.idDesconto) getDescontoById();
    }, [props.idDesconto, token]);


    const handleClose = () => {
        props.setEditarDesconto(false);
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        if (discountCode === '' || valorDesconto === '' || duracaoMeses === '') {
            alert('Por favor, preencha todos os campos.');
            return;
        }
        try {
            setSalvando(true);
            await axios.put(`${process.env.REACT_APP_API_URL}/atualizarDesconto/${props.idDesconto}`, {
                discountCode,
                valorDesconto,
                duracaoMeses
            }, {
                headers: {
                    Authorization: token
                }
            });
            handleClose();
        } catch (error) {
            console.error("Erro ao atualizar desconto:", error);
        } finally {
            setSalvando(false);
        }
    };

    return (
        <FormularioDesconto
            aberto={props.editarDesconto}
            titulo="Editar desconto"
            descricao="Altere o código, o percentual ou a duração do desconto."
            textoBotao="Salvar alterações"
            salvando={salvando}
            onClose={handleClose}
            onSubmit={handleSubmit}
            discountCode={discountCode}
            setDiscountCode={setDiscountCode}
            valorDesconto={valorDesconto}
            setValorDesconto={setValorDesconto}
            duracaoMeses={duracaoMeses}
            setDuracaoMeses={setDuracaoMeses}
        />
    );
}
